import { type IkeClientService, Services } from './index';
import type { BoundWindow } from './window.service';

interface FocusAwayEvent {
	element: HTMLElement;
	callback: () => void;
}

export class FocusAwayService implements IkeClientService {
	__priority = 100;

	private events: FocusAwayEvent[] = [];

	init() {
		Services.Window.window.addEventListener('mousedown', (evt: MouseEvent) =>
			this.runMouse(evt, Services.Window.window)
		);
	}

	from(element: HTMLElement, callback: () => void) {
		const existingEvent = this.events.find((e) => e.element === element);
		if (existingEvent) {
			existingEvent.callback = callback;
			return;
		}

		const newEvent: FocusAwayEvent = {
			element,
			callback,
		};

		this.events.push(newEvent);
	}

	private runMouse(evt: MouseEvent, win: BoundWindow) {
		if (this.events.length === 0) {
			return;
		}
		this.purgeEvents(win);
		this.events
			.filter((focusAwayEvent) => !focusAwayEvent.element.contains(evt.target as HTMLElement))
			.forEach((focusAwayEvent) => focusAwayEvent.callback.call(null));
	}

	public drop(element: HTMLElement, callback: () => void) {
		this.events = this.events.filter((e) => !(e.element === element && e.callback === callback));
	}

	public dropByElement(element: HTMLElement) {
		this.events = this.events.filter((e) => !(e.element === element));
	}

	private purgeEvents(win: BoundWindow) {
		this.events = this.events.filter((focusAwayEvent) => win.document.contains(focusAwayEvent.element));
	}
}
